import React from 'react';
import { CompanyAdminMeta, CompanyRole } from '@dispatch/shared/types';
import { AdminDashboardTable } from './AdminDashboardTable';
import {
  GridActionsCellItem,
  GridColumns,
  GridRowParams,
} from '@mui/x-data-grid';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import EditIcon from '@mui/icons-material/Edit';
import { handleModalOpen, onClick } from './helpers';
import DeleteIcon from '@mui/icons-material/Delete';

export const ResourceRoleAdmin = ({
  resourceRoles = [],
  modalState,
  isLoading,
}: {
  resourceRoles?: CompanyRole[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addResourceRole', params, modalState),
    [modalState?.meta.addResourceRole]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'role';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColumns = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
      flex: 2,
    }),
    textColumn({
      field: 'name',
      headerName: 'Name',
      flex: 2,
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<CompanyRole>
      isLoading={isLoading}
      columns={columns}
      data={resourceRoles}
      type="resource-role"
      identifier="integrationGUID"
      handleClick={() => handleModalOpen('addResourceRole', modalState)}
    />
  );
};
